import { composeFetch } from '@library/http'
import {
  addPath,
  composeRequest,
  goustoHeaders,
  setMethod,
  setQueryParams,
  setServiceUrl,
} from '@library/http/requests'

import type { RecipeQueryInput, RecipeQueryResponse } from './interfaces/recipe'

const getResponseParser = async (response: Response): Promise<RecipeQueryResponse> => {
  if (!response.ok) {
    const responseMsg = await response.text()
    throw new Error(`service responded with ${response.status}: ${responseMsg}`)
  }

  const parsedBody = await response.json()

  return { ...parsedBody, responseType: 'experience' } as RecipeQueryResponse
}

export const recipeFetcher = composeFetch(
  composeRequest<RecipeQueryInput>(
    setServiceUrl('menuexperience', 1),
    addPath((input) => `recipes/${input.recipeId}`),
    goustoHeaders,
    setMethod('GET'),
    setQueryParams(({ numPortions, menuId, collectionId, deliveryDate }) => {
      return {
        numPortions: numPortions.toString(),
        menuId,
        ...(deliveryDate && { deliveryDate }),
        ...(collectionId && { collectionId }),
      }
    }),
  ),
  getResponseParser,
)
